module.exports = __webpack_public_path__ + "img/mobileScreenFeature2.64e1cecb.svg";